module.exports = __webpack_public_path__ + "img/gallery10.07534b83.png";